import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackAddUserToWishListParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/wishList/trackAddUserToWishList";

const useTrackAddUserToWishList = (
    parameters: TrackAddUserToWishListParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.addUserToWishList, parameters, options);
};

export default useTrackAddUserToWishList;
